import React from 'react';
import { Modal } from 'react-bootstrap';
import { formatUseYn } from '@utils/formatUseYn';

const CodeHDetailModal = ({ open, onClose, item }) => {
    return (
        <Modal show={open} onHide={onClose} centered className="md:hidden">
            <Modal.Header>
                <Modal.Title className="text-lg font-extrabold">공통코드(H) 상세</Modal.Title>
                <button type="button" className="modal-btn-close" onClick={onClose}>
                    <span className="modal-btn-span">X</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                {item ? (
                    <div className="space-y-3 text-[15px]">
                        <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0">
                                <p className="text-[13px] text-gray-500">그룹명</p>
                                <p className="font-bold text-gray-900 break-words">{item.comhName}</p>
                            </div>
                            <span className="shrink-0 font-mono text-[13px] text-gray-600">{item.comhCode}</span>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <p className="text-[13px] text-gray-500">정렬</p>
                                <p className="font-mono text-gray-900">{item.hsort}</p>
                            </div>
                            <div>
                                <p className="text-[13px] text-gray-500">사용</p>
                                <p className="font-bold text-gray-900">{formatUseYn(item.huseYn)}</p>
                            </div>
                        </div>
                        <div>
                            <p className="text-[13px] text-gray-500">비고</p>
                            <p className="text-gray-900 whitespace-pre-wrap break-words">{item.hnotice || '-'}</p>
                        </div>
                    </div>
                ) : null}
            </Modal.Body>
        </Modal>
    );
};

export default CodeHDetailModal;
